<div *ngIf="!spinnerOnInit">

    <div *ngIf="this.aantalValidaties > 0">
        De aangifte bevat nog validatiemeldingen. Klik op de button 'Validaties' in het menu en bekijk om welke
        validaties het gaat. <br/>Pas dan de gegevens aan zodat alle validatiemeldingen verdwijnen. Daarna kan er
        (opnieuw) verdeeld worden.
    </div>

    <div *ngIf="this.aantalValidaties === 0">
        <div *ngIf="totaalEigenwoningVerdeling !== 0 || totaalBox2Verdeling !== 0 || totaalBox3Verdeling !== 0 ||totaalPGAVerdeling !== 0  || totaalDividendbelastingVerdeling !== 0">
            <snelstart-ui-alert style="width: 75%" type="info">
                Verdeel onderstaand de gezamenlijke posten door te klikken op de button '<b>Pas de voorgestelde
                verdeling toe</b>'.<br/>
                Of vul zelf bij de aangever in de 2e kolom ('Toe te passen verdeling) een bedrag in. Het aandeel van de
                partner wordt automatisch berekend.<br/>
                Je kunt een gekozen verdeling ook altijd wijzigen door het aandeel van de aangever aan te passen.
            </snelstart-ui-alert>

            <div class="space20"></div>

            <div class="row col-auto">
                <div class="pe-2" style="width: 725px; text-align: end; ">
                    <b>TOE TE PASSEN VERDELING</b>
                </div>
                <div class="pe-2" style="width: 350px; margin-left: 25px; text-align: end;">
                    <b>VOORSTEL VERDELING</b>
                </div>
            </div>

            <div class="row pt-1">
                <div class="pe-2" style="width: 300px; text-align: start">
                    <p></p>
                </div>
                <div class="pe-4" style="width: 150px; flex: 1; text-align: center; ">
                    <p><b>Totaal</b></p>
                </div>
                <div class="pe-3" style="width: 150px; flex: 1; text-align: center; ">
                    <p><b>Aangever</b></p>
                </div>
                <div class="pe-5" style="width: 150px; flex: 1; text-align: center; ">
                    <p><b>Partner</b></p>
                </div>
                <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: center;">
                    <p><b>Aangever</b></p>
                </div>
                <div style="width: 150px; flex: 1; text-align: center;">
                    <p><b>Partner</b></p>
                </div>
                <div style="width: 50px;"></div>
            </div>

            <!--          Gekozen Verdeling-->
            <div *ngIf="(totaalEigenwoningVerdeling !== 0)">
                <div class="pt-1 row">
                    <form (change)="saveForm()" [formGroup]="gekozenVerdelingFg" class="d-contents">
                        <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                            <p>Inkomsten uit eigen woning</p>
                        </div>
                        <div class="pe-4" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="totaalEigenWoning"
                                    id="totaalEigenWoningGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-125"
                                    formControlName="aandeelEigenWoningAangever"
                                    id="aandeelEigenWoningAangeverGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-5" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelEigenWoningPartner"
                                    id="aandeelEigenWoningPartnerGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </form>
                    <form [formGroup]="optimaleVerdelingFg" class="d-contents">
                        <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="custom-input-125"
                                    formControlName="aandeelEigenWoningAangever"
                                    id="aandeelEigenWoningAangever"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelEigenWoningPartner"
                                    id="aandeelEigenWoningPartner"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 50px;"></div>
                    </form>
                </div>
                <div *ngIf="hasEigenWoningen()" class="pt-1 row">
                    <form (change)="saveForm()" [formGroup]="gekozenVerdelingFg" class="d-contents">
                        <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                            <p>Aftrek geen/kleine eigenwoningschuld</p>
                        </div>
                        <div class="pe-4" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="totaalGOGEWS"
                                    id="totaalGOGEWSGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="custom-input-125"
                                    formControlName="aandeelGOGEWSAangever"
                                    id="aandeelGOGEWSAangeverGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-5" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelGOGEWSPartner"
                                    id="aandeelGOGEWSPartnerGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </form>
                    <form [formGroup]="optimaleVerdelingFg" class="d-contents">
                        <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="custom-input-125"
                                    formControlName="aandeelGOGEWSAangever"
                                    id="aandeelGOGEWSAangever"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelGOGEWSPartner"
                                    id="aandeelGOGEWSPartner"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 50px;"></div>
                    </form>
                </div>
            </div>

            <div *ngIf="(totaalBox2Verdeling !== 0)">
                <div class="pt-1 row">
                    <form (change)="saveForm()" [formGroup]="gekozenVerdelingFg" class="d-contents">
                        <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                            <p>Voordeel aanmerkelijk belang</p>
                        </div>
                        <div class="pe-4" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="totaalBox2"
                                    id="totaalBox2Gekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-125"
                                    formControlName="aandeelBox2Aangever"
                                    id="aandeelBox2AangeverGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-5" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelBox2Partner"
                                    id="aandeelBox2PartnerGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </form>
                    <form [formGroup]="optimaleVerdelingFg" class="d-contents">
                        <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="custom-input-125"
                                    formControlName="aandeelBox2Aangever"
                                    id="aandeelBox2Aangever"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelBox2Partner"
                                    id="aandeelBox2Partner"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 50px;"></div>
                    </form>
                </div>
            </div>

            <div *ngIf="totaalBox3Verdeling !== 0 && !this.berekenRendementsGrondslagRegelingen()">
                <div class="pt-1 row">
                    <form (change)="saveForm()" [formGroup]="gekozenVerdelingFg" class="d-contents">
                        <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                            <p>Grondslag sparen en beleggen</p>
                        </div>
                        <div class="pe-4" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="totaalBox3"
                                    id="totaalBox3Gekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-125"
                                    formControlName="aandeelBox3Aangever"
                                    id="aandeelBox3AangeverGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-5" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelBox3Partner"
                                    id="aandeelBox3PartnerGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </form>
                    <form [formGroup]="optimaleVerdelingFg" class="d-contents">
                        <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="custom-input-125"
                                    formControlName="aandeelBox3Aangever"
                                    id="aandeelBox3AangeverOptimaal"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelBox3Partner"
                                    id="aandeelBox3PartnerOptimaal"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 50px;"></div>
                    </form>
                </div>
            </div>

            <!--            <div class="pt-5" *ngIf="">-->
            <!--                <form [formGroup]="gekozenVerdelingFg" (change)="saveForm()">-->
            <!--                    <div class="d-flex align-items-center">-->
            <!--                        <div class="pe-2" style="width: 250px; text-align: start">-->
            <!--                            <p>Vrijstelling groene beleggingen</p>-->
            <!--                        </div>-->
            <!--                        <div class="pe-2" style="flex: 1; text-align: end; font-weight: bold;">-->
            <!--                            <snelstart-ui-number-form-control-->
            <!--                                    formControlName="totaalRendementsGrondslag"-->
            <!--                                    id="totaalRendementsGrondslag"-->
            <!--                                    class="me-1 custom-input-125 custom-readonly"-->
            <!--                                    [disabledControl]="true"-->
            <!--                                    [decimals]="0"-->
            <!--                                    align="right"-->
            <!--                                    prefix="€"-->
            <!--                            ></snelstart-ui-number-form-control>-->
            <!--                        </div>-->
            <!--                        <div class="pe-2" style="flex: 1; text-align: end; font-weight: bold;">-->
            <!--                            <snelstart-ui-number-form-control-->
            <!--                                    formControlName="aandeelRendementsGrondslagAangever"-->
            <!--                                    id="aandeelRendementsGrondslagAangeverGekozen"-->
            <!--                                    class="me-1 custom-input-125 "-->
            <!--                                    [decimals]="0"-->
            <!--                                    align="right"-->
            <!--                                    prefix="€"-->
            <!--                                    (change)="saveForm()"-->
            <!--                            ></snelstart-ui-number-form-control>-->
            <!--                        </div>-->
            <!--                        <div class="pe-2" style="flex: 1; text-align: end; font-weight: bold;">-->
            <!--                            <snelstart-ui-number-form-control-->
            <!--                                    formControlName="aandeelRendementsGrondslagPartner"-->
            <!--                                    id="aandeelRendementsGrondslagPartnerGekozen"-->
            <!--                                    class="me-1 custom-input-125 custom-readonly"-->
            <!--                                    [disabledControl]="true"-->
            <!--                                    [decimals]="0"-->
            <!--                                    align="right"-->
            <!--                                    prefix="€"-->
            <!--                            ></snelstart-ui-number-form-control>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </form>-->
            <!--                <form [formGroup]="optimaleVerdelingFg">-->
            <!--                    <div class="d-flex align-items-center" style="margin-top: 4px">-->
            <!--                        <div class="pe-2" style="flex: 1; text-align: end; font-weight: bold; margin-left: 75px">-->
            <!--                            <snelstart-ui-number-form-control-->
            <!--                                    formControlName="aandeelRendementsgrondslagAangever"-->
            <!--                                    id="aandeelRendementsgrondslagAangeverOptimaal"-->
            <!--                                    class="custom-input-125"-->
            <!--                                    [decimals]="0"-->
            <!--                                    [disabledControl]="true"-->
            <!--                                    align="right"-->
            <!--                                    prefix="€"-->
            <!--                            ></snelstart-ui-number-form-control>-->
            <!--                        </div>-->
            <!--                        <div class="pe-2" style="flex: 1; text-align: end; font-weight: bold;">-->
            <!--                            <snelstart-ui-number-form-control-->
            <!--                                    formControlName="aandeelRendementsgrondslagPartner"-->
            <!--                                    id="aandeelRendementsgrondslagPartnerOptimaal"-->
            <!--                                    class="me-1 custom-input-125 custom-readonly"-->
            <!--                                    [disabledControl]="true"-->
            <!--                                    [decimals]="0"-->
            <!--                                    align="right"-->
            <!--                                    prefix="€"-->
            <!--                            ></snelstart-ui-number-form-control>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </form>-->
            <!--            </div>-->

            <div *ngIf="(totaalPGAVerdeling !== 0)">
                <div class="pt-1 row">
                    <form (change)="saveForm()" [formGroup]="gekozenVerdelingFg" class="d-contents">
                        <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                            <p>Persoonsgebonden aftrek</p>
                        </div>
                        <div class="pe-4" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="totaalPGA"
                                    id="totaalPGAGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-125"
                                    formControlName="aandeelPGAAangever"
                                    id="aandeelPGAAangeverGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-5" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelPGAPartner"
                                    id="aandeelPGAPartnerGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </form>
                    <form [formGroup]="optimaleVerdelingFg" class="d-contents">
                        <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="custom-input-125"
                                    formControlName="aandeelPGAAangever"
                                    id="aandeelPGAAangevrOptimaal"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelPGAPartner"
                                    id="aandeelPGAPartnerOptimaal"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 50px;"></div>
                    </form>
                </div>
            </div>

            <div *ngIf="(totaalDividendbelastingVerdeling !== 0)">
                <div class="pt-1 row">
                    <form (change)="saveForm()" [formGroup]="gekozenVerdelingFg" class="d-contents">
                        <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                            <p>Ingehouden dividendbelasting</p>
                        </div>
                        <div class="pe-4" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="totaalDividendbelasting"
                                    id="totaalDividendbelastingGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="me-1 custom-input-125 "
                                    formControlName="aandeelDividendbelastingAangever"
                                    id="aandeelDividendbelastingAangeverGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="pe-5" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelDividendbelastingPartner"
                                    id="aandeelDividendbelastingPartnerGekozen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </form>
                    <form [formGroup]="optimaleVerdelingFg" class="d-contents">
                        <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 "
                                    formControlName="aandeelDividendbelastingAangever"

                                    id="aandeelDividendbelastingAangeverOptimaal"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 150px; flex: 1; text-align: end;">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    [disabledControl]="true"
                                    align="right"
                                    class="me-1 custom-input-125 custom-readonly"
                                    formControlName="aandeelDividendbelastingPartner"
                                    id="aandeelDividendbelastingPartnerOptimaal"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div style="width: 50px;"></div>
                    </form>
                </div>
            </div>

            <form [formGroup]="berekeningFg" [noValidate]="berekeningFg">
                <div class="pt-1 row gx-0">
                    <div class="pe-2" style="width: 300px; text-align: start">
                        <p></p>
                    </div>
                    <div class="pe-4" style="width: 150px; flex: 1; text-align: center;">
                        <p *ngIf="berekeningFg.value.verschuldigdeInkomstenbelastingGezamenlijkGekozen !== null &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingGezamenlijkGekozen !== undefined &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingGezamenlijkGekozen > 0">
                            <b>Te betalen</b></p>
                        <p *ngIf="berekeningFg.value.verschuldigdeInkomstenbelastingGezamenlijkGekozen !== null &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingGezamenlijkGekozen !== undefined &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingGezamenlijkGekozen < 0">
                            <b>Te ontvangen</b></p>
                    </div>
                    <div class="pe-3" style="width: 150px; flex: 1; text-align: center;">
                        <p *ngIf="berekeningFg.value.verschuldigdeInkomstenbelastingAangeverGekozen !== null &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingAangeverGekozen !== undefined &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingAangeverGekozen > 0">
                            <b>Te betalen</b></p>
                        <p *ngIf="berekeningFg.value.verschuldigdeInkomstenbelastingAangeverGekozen !== null &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingAangeverGekozen !== undefined &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingAangeverGekozen < 0">
                            <b>Te ontvangen</b></p>
                    </div>
                    <div class="pe-5" style="width: 150px; flex: 1; text-align: center;">
                        <p *ngIf="berekeningFg.value.verschuldigdeInkomstenbelastingPartnerGekozen !== null &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingPartnerGekozen !== undefined &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingPartnerGekozen > 0">
                            <b>Te betalen</b></p>
                        <p *ngIf="berekeningFg.value.verschuldigdeInkomstenbelastingPartnerGekozen !== null &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingPartnerGekozen !== undefined &&
                        berekeningFg.value.verschuldigdeInkomstenbelastingPartnerGekozen < 0">
                            <b>Te ontvangen</b></p>
                    </div>
                    <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: center;">
                      @if(berekeningFg.getRawValue() && berekeningFg.getRawValue().verschuldigdeInkomstenbelastingAangeverOptimaal && berekeningFg.getRawValue().verschuldigdeInkomstenbelastingAangeverOptimaal! >0) {
                        <b>Te betalen</b>
                      }
                      @if (berekeningFg.getRawValue() && berekeningFg.getRawValue().verschuldigdeInkomstenbelastingAangeverOptimaal && berekeningFg.getRawValue().verschuldigdeInkomstenbelastingAangeverOptimaal! < 0) {
                        <b>Te ontvangen</b>
                      }
<!--                        <p *ngIf="berekeningFg.getRawValue().verschuldigdeInkomstenbelastingAangeverOptimaal!.valueOf() > 0">-->
<!--                            <b>Te betalen</b></p>-->
<!--                        <p *ngIf="berekeningFg.getRawValue().verschuldigdeInkomstenbelastingAangeverOptimaal!.valueOf() < 0">-->
<!--                            <b>Te ontvangen</b></p>-->
                    </div>
                    <div style="width: 150px; flex: 1; text-align: center;">
                      @if(berekeningFg.getRawValue() && berekeningFg.getRawValue().verschuldigdeInkomstenbelastingPartnerOptimaal && berekeningFg.getRawValue().verschuldigdeInkomstenbelastingPartnerOptimaal! >0) {
                        <b>Te betalen</b>
                      }
                      @if (berekeningFg.getRawValue() && berekeningFg.getRawValue().verschuldigdeInkomstenbelastingPartnerOptimaal && berekeningFg.getRawValue().verschuldigdeInkomstenbelastingPartnerOptimaal! < 0) {
                        <b>Te ontvangen</b>
                      }
<!--                        <p *ngIf="berekeningFg.value.verschuldigdeInkomstenbelastingPartnerOptimaal!.valueOf() > 0">-->
<!--                            <b>Te betalen</b></p>-->
<!--                        <p *ngIf="berekeningFg.value.verschuldigdeInkomstenbelastingPartnerOptimaal!.valueOf() < 0">-->
<!--                            <b>Te ontvangen</b></p>-->
                    </div>
                    <div style="width: 50px;"></div>
                </div>
                <div class="row gx-0">
                    <div class="pe-2" style="width: 300px; text-align: start">
                        <p>Berekende belasting</p>
                    </div>
                    <div class="pe-4" style="width: 150px; flex: 1; text-align: end; margin-left: -11px;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                class="me-1 custom-input-125 "
                                formControlName="verschuldigdeInkomstenbelastingGezamenlijkGekozen"
                                id="verschuldigdeInkomstenbelastingGezamenlijkGekozen"
                                placeholder="?"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-3" style="width: 150px; flex: 1; text-align: end; margin-left: 5px">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                class="me-1 custom-input-125 "
                                formControlName="verschuldigdeInkomstenbelastingAangeverGekozen"
                                id="verschuldigdeInkomstenbelastingAangeverGekozen"
                                placeholder="?"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-5" style="width: 150px; flex: 1; text-align: end; margin-left: 5px">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                class="me-1 custom-input-125 custom-readonly"
                                formControlName="verschuldigdeInkomstenbelastingPartnerGekozen"
                                id="verschuldigdeInkomstenbelastingPartnerGekozen"
                                placeholder="?"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: end; margin-left: 5px">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                class="me-1 custom-input-125 custom-readonly"
                                formControlName="verschuldigdeInkomstenbelastingAangeverOptimaal"
                                id="verschuldigdeInkomstenbelastingAangeverOptimaal"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div style="width: 150px; flex: 1; text-align: end; margin-left: 5px">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                class="me-1 custom-input-125 custom-readonly"
                                formControlName="verschuldigdeInkomstenbelastingPartnerOptimaal"
                                id="verschuldigdeInkomstenbelastingPartnerOptimaal"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div style="width: 50px;"></div>
                </div>

            </form>
            <div *ngIf="this.aantalValidaties === 0">
                <div *ngIf="this.toonVoorstelKnop()">
                    <snelstart-ui-button
                            (click)="this.patchGekozenVerdelingMetOptimaleVerdeling()"
                            class="pt-2"
                            icon="split"
                            type="primary"
                    >
                        Pas de voorgestelde verdeling toe
                    </snelstart-ui-button>
                </div>

                <div *ngIf="!this.toonVoorstelKnop()">

                    <div *ngIf="this.totaalVerschuldigdIbOptimaal >  0 ? (this.totaalVerschuldigdIb > this.totaalVerschuldigdIbOptimaal) :
                        (this.totaalVerschuldigdIbOptimaal < this.totaalVerschuldigdIb)">

                        <div class="space20"></div>

                        <snelstart-ui-alert [showIcon]="false" type="warning">
                            <div class="space10"></div>
                            Let op! De totale belasting bij de gekozen verdeling bedraagt
                            <b>€ {{ this.totaalVerschuldigdIb | number: '1.0-0' }}</b>.
                            Dat is
                            <b>€ {{ this.totaalVerschuldigdIb - this.totaalVerschuldigdIbOptimaal | number: '1.0-0' }}
                                verschil</b> met de totale belasting bij de voorgestelde verdeling van
                            <b>€ {{ this.totaalVerschuldigdIbOptimaal | number: '1.0-0' }}</b>.
                            <div class="space20"></div>
                            <snelstart-ui-button
                                    (click)="this.patchGekozenVerdelingMetOptimaleVerdeling()"
                                    class="pb-1"
                                    type="link"
                            >
                                <u><b>Klik HIER voor toepassen voorgestelde verdeling</b></u>
                            </snelstart-ui-button>

                        </snelstart-ui-alert>
                    </div>
                </div>

                <div *ngIf="this.berekenRendementsGrondslagRegelingen()">

                    <div class="pt-5 row">
                        <form [formGroup]="rendementsGrondslagFormGroup" class="d-contents">
                            <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                                <p>Vermogen voor inkomensafh. regelingen</p>
                            </div>
                            <div class="pe-4" style="width: 150px; flex: 1; text-align: end;">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        [disabledControl]="true"
                                        align="right"
                                        class="me-1 custom-input-125 custom-readonly"
                                        formControlName="rendementsGrondslag"
                                        id="rendementsGrondslag"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="pe-3" style="width: 150px; flex: 1; text-align: end; ">
                                <snelstart-ui-number-form-control
                                        (change)="saveForm()"
                                        [decimals]="0"
                                        align="right"
                                        class="me-1 custom-input-125 "
                                        formControlName="aandeelRendementsGrondslagVoorRegelingenAangever"
                                        id="aandeelRendementsGrondslagVoorRegelingenAangever"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="pe-5" style="width: 150px; flex: 1; text-align: end; ">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        [disabledControl]="true"
                                        align="right"
                                        class="me-1 custom-input-125 custom-readonly"
                                        formControlName="aandeelRendementsGrondslagVoorRegelingenPartner"
                                        id="aandeelRendementsGrondslagVoorRegelingenPartner"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: end;"></div>
                            <div style="width: 150px; flex: 1; text-align: end;"></div>
                            <div style="width: 50px;"></div>
                        </form>
                    </div>

                    <div *ngIf="!this.controleerRendementsGrondslag().valueOf()">
                        Verdeel het vermogen tussen aangever en partner (zie toelichting)
                    </div>

                </div>
            </div>

            <div class="space40"></div>

        </div>
    </div>

</div>


<snelstart-ui-spinner *ngIf="spinnerOptimalisatie"></snelstart-ui-spinner>

<ng-container *ngIf="spinnerOnInit">
    <snelstart-ui-spinner size="extraLarge"></snelstart-ui-spinner>
</ng-container>



